import NoteContent from './NoteContent';

export default NoteContent;